import React from 'react'
import { useTranslation } from 'react-i18next'
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay'
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Divider,
  Typography,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { styled } from '@mui/system'
import { GridDeleteIcon } from '@mui/x-data-grid'
import { FetchUserPlaylistsResponsePlaylistsPlaylistTypeEnum as playlistTypeEnum } from '../../swagger'
import { PLAYLIST_TEXT_TRUNCATION_LIMIT_CARD } from '../../utils/constants'
import RowActions, { Action } from '../Table/RowActions'

interface ContentDetailPlaylistProps {
  name: string
  playlistType: playlistTypeEnum
  onClick?: () => void
  onDeleteClick: () => void
}

interface PlaylistRow {
  handleClick: () => void
}

const PlaylistCenterCard = styled(Card)(({ theme }) => ({
  width: 220,
  margin: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    maxWidth: 220,
    marginTop: theme.spacing(2),
    '&:nth-of-type(1)': {
      marginTop: 0,
    },
  },
}))

const ContentDetailPlaylistCard: React.FC<ContentDetailPlaylistProps> = ({
  name,
  playlistType,
  onClick,
  onDeleteClick,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const playlistActions: Action<PlaylistRow>[] = [
    {
      actionName: t(
        'ContentDetailPlaylist.PlaylistMenu.Action.Delete',
        'Delete'
      ),
      actionKey: 'deletePlaylist',
      actionFunction: (row) => row.handleClick(),
      menuItemIcon: <GridDeleteIcon />,
    },
  ]

  return (
    <PlaylistCenterCard>
      <CardActionArea>
        <CardContent>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height={theme.spacing(15.7)}
            onClick={onClick}
          >
            <PlaylistPlayIcon sx={{ fontSize: theme.spacing(10) }} />
          </Box>
        </CardContent>
      </CardActionArea>
      <Divider />
      <CardContent sx={{ position: 'relative' }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          <Box
            sx={{
              pt: 0,
              mt: theme.spacing(1),
              overflow: 'hidden',
            }}
          >
            <Typography
              noWrap
              lineHeight={1}
              variant="h6"
              sx={{
                fontWeight: 'normal',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {name.length > PLAYLIST_TEXT_TRUNCATION_LIMIT_CARD
                ? `${name.slice(0, PLAYLIST_TEXT_TRUNCATION_LIMIT_CARD)}...`
                : name}
            </Typography>
            <Typography
              sx={{ textTransform: 'capitalize' }}
              lineHeight={2}
              display="flex"
              variant="overline"
            >
              {playlistType === 'LearningCenter'
                ? 'Learning Center'
                : 'Business Center'}
            </Typography>
          </Box>
          <RowActions
            elementsCount={playlistActions.length}
            actions={playlistActions}
            row={{ handleClick: onDeleteClick }}
            scrollToFirstStep
          />
        </Box>
      </CardContent>
    </PlaylistCenterCard>
  )
}

export default ContentDetailPlaylistCard
